import React from "react";
import { Card } from "@/components/ui/card";
import { useOnboarding } from "@/context/OnboardingContext";
import StickyOnboardingFooter from "./StickyOnboardingFooter";

const OrientationStep = () => {
  const { data, updateData, nextStep, saveStepData } = useOnboarding();
  const selectedOrientation = data.orientation;
  const userGender = data.gender;

  const handleSelectOrientation = (orientation: string) => {
    updateData({ orientation: orientation as any });
  };

  const handleNext = async () => {
    await saveStepData(3, data);
    nextStep();
  };

  // Determine emojis for homosexual based on gender
  const getHomosexualEmojis = () => {
    if (userGender === "male") {
      return "👨‍❤️‍👨";
    } else if (userGender === "female") {
      return "👩‍❤️‍👩";
    } else {
      return "❤️";
    }
  };

  return (
    <StickyOnboardingFooter
      buttonText="Continuar"
      onClick={handleNext}
      disabled={!selectedOrientation}
    >
      <div className="max-w-lg mx-auto">
        <div className="text-center mb-4 md:mb-8">
          <h1 className="text-xl md:text-2xl font-bold text-white mb-1 md:mb-2">
            Qual é sua orientação?
          </h1>
          <p className="text-xs md:text-sm text-white/70">
            Isso nos ajuda a encontrar conexões mais compatíveis
          </p>
        </div>

        <div className="space-y-2 md:space-y-4">
          <Card 
            className={`bg-black/40 backdrop-blur-sm border-2 shadow-2xl cursor-pointer transition-all duration-300 hover:bg-black/50 ${
              selectedOrientation === "straight" ? "border-luxury-pinkBright shadow-luxury-pinkBright/25" : "border-transparent"
            }`}
            onClick={() => handleSelectOrientation("straight")}
            data-testid="orientation-card-straight"
          >
            <div className="p-4 md:p-6 flex items-center justify-between">
              <div className="flex items-center space-x-3 md:space-x-4">
                <div className="p-2 md:p-3 rounded-full bg-red-500/20 flex items-center justify-center">
                  <span className="text-xl md:text-2xl">💑</span>
                </div>
                <div>
                  <h3 className="text-lg md:text-xl font-medium text-white">Heterossexual</h3>
                  <p className="text-white/70 text-xs md:text-sm">Interesse pelo sexo oposto</p>
                </div>
              </div>
              <div className={`h-5 w-5 rounded-full border-2 flex items-center justify-center ${
                selectedOrientation === "straight" ? "bg-luxury-pinkBright border-luxury-pinkBright" : "border-white/30"
              }`}>
                {selectedOrientation === "straight" && (
                  <div className="h-2 w-2 rounded-full bg-white"></div>
                )}
              </div>
            </div>
          </Card>

          <Card 
            className={`bg-black/40 backdrop-blur-sm border-2 shadow-2xl cursor-pointer transition-all duration-300 hover:bg-black/50 ${
              selectedOrientation === "gay" ? "border-luxury-pinkBright shadow-luxury-pinkBright/25" : "border-transparent"
            }`}
            onClick={() => handleSelectOrientation("gay")}
            data-testid="orientation-card-gay"
          >
            <div className="p-4 md:p-6 flex items-center justify-between">
              <div className="flex items-center space-x-3 md:space-x-4">
                <div className="p-2 md:p-3 rounded-full bg-purple-500/20 flex items-center justify-center">
                  <span className="text-xl md:text-2xl">{getHomosexualEmojis()}</span>
                </div>
                <div>
                  <h3 className="text-lg md:text-xl font-medium text-white">Homossexual</h3>
                  <p className="text-white/70 text-xs md:text-sm">Interesse pelo mesmo sexo</p>
                </div>
              </div>
              <div className={`h-5 w-5 rounded-full border-2 flex items-center justify-center ${
                selectedOrientation === "gay" ? "bg-luxury-pinkBright border-luxury-pinkBright" : "border-white/30"
              }`}>
                {selectedOrientation === "gay" && (
                  <div className="h-2 w-2 rounded-full bg-white"></div>
                )}
              </div>
            </div>
          </Card>

          <Card 
            className={`bg-black/40 backdrop-blur-sm border-2 shadow-2xl cursor-pointer transition-all duration-300 hover:bg-black/50 ${
              selectedOrientation === "bisexual" ? "border-luxury-pinkBright shadow-luxury-pinkBright/25" : "border-transparent"
            }`}
            onClick={() => handleSelectOrientation("bisexual")}
            data-testid="orientation-card-bisexual"
          >
            <div className="p-4 md:p-6 flex items-center justify-between">
              <div className="flex items-center space-x-3 md:space-x-4">
                <div className="p-2 md:p-3 rounded-full bg-gradient-to-r from-pink-500/20 to-blue-500/20">
                  <span className="text-xl md:text-2xl">✨</span>
                </div>
                <div>
                  <h3 className="text-lg md:text-xl font-medium text-white">Bissexual</h3>
                  <p className="text-white/70 text-xs md:text-sm">Interesse por ambos os sexos</p>
                </div>
              </div>
              <div className={`h-5 w-5 rounded-full border-2 flex items-center justify-center ${
                selectedOrientation === "bisexual" ? "bg-luxury-pinkBright border-luxury-pinkBright" : "border-white/30"
              }`}>
                {selectedOrientation === "bisexual" && (
                  <div className="h-2 w-2 rounded-full bg-white"></div>
                )}
              </div>
            </div>
          </Card>
        </div>
      </div>
    </StickyOnboardingFooter>
  );
};

export default OrientationStep;
